import { createRoute, redirect } from '@tanstack/react-router'
import { projectRoute } from '../route'

/** Old bookmarks: `/…/meetings[/id]` → `/…/calendar[/id]`. */
export const legacyMeetingsRedirectRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/meetings/$',
  beforeLoad: ({ params }) => {
    const rest = (params as { _splat?: string })._splat ?? ''
    throw redirect({
      to: rest ? '/$projectId/calendar/$meetingId' : '/$projectId/calendar',
      params: { projectId: params.projectId, meetingId: rest.split('/')[0] },
    })
  },
})
